import React, {useContext, useEffect} from 'react';
import {HashRouter, Route, Switch, useRouteMatch, withRouter} from 'react-router-dom';
import {ReservationWrapper} from "./Reservation.style";
import {Loader} from '../../components/common';
import { ReservationRoutes } from "./routes";
import {ReservationInputs} from "./components/ReservationInputs";
import {useDispatch, useSelector} from "react-redux";
import {selectReady} from "../../store/slices/app/selectors";
import {appActions} from "../../store/slices/app/appSlice";
import {authActions} from "../../store/slices/auth/authSlice";
import ReservationData from "./components/ReservationData/ReservationData";
import PropTypes from "prop-types";
import {GlobalContext} from "../../context/GlobalProvider";
import { reservationActions } from 'store/slices/reservation/reservationSlice';

const MarinaReservation = props => {
    const {marina} = props;
    const dispatch = useDispatch();
    const ready = useSelector(selectReady);
    const { marinas } = useContext(GlobalContext);

    useEffect(() => {
        dispatch(appActions.initializeForMarina({ marina, marinas }));
        dispatch(authActions.init());
        return () => {
            dispatch(reservationActions.clear());
        };
    }, [marina, marinas, dispatch]);

    if(!ready) return null;

    return (<ReservationWrapper>
        <HashRouter basename="">
            <Switch>
                <Route exact path={`/${ReservationRoutes.Home}`} component={ReservationInputs} />
                <Route path={`/${ReservationRoutes.Finished}`} component={ReservationData} />
                <Route path={`/${ReservationRoutes.Reservation}`} component={ReservationData} />
            </Switch>
        </HashRouter>
        <Loader />
    </ReservationWrapper>);
}

MarinaReservation.propTypes = {
    marina: PropTypes.object
}

export default withRouter(MarinaReservation);
